<template>
  <div style="display: inline-block; vertical-align: inherit;">
    <a-tooltip placement="top">
      <template v-if="tooltip" slot="title">
        <span>{{ customerFullName }}</span>
      </template>
      <template v-if="link">
        <a v-if="customerIsBusiness" :href="customerDashboardURI" v-on:click.stop
           v-bind:class="{ passedAway: customer.passed_away }">
          <customer-avatar v-bind:customer-id="customer.id" v-bind:size="size"/>
          <span>{{ customerFullName }}</span>
        </a>
        <a v-else :href="customerDashboardURI" v-on:click.stop v-bind:class="{ passedAway: customer.passed_away }">
          <customer-avatar v-bind:customer-id="customer.id" v-bind:size="size"/>

          <gender-male-icon v-if="customer.sex === 1"></gender-male-icon>
          <gender-female-icon v-if="customer.sex === 0"></gender-female-icon>
          <help-icon v-if="customer.sex === null"></help-icon>

          {{ customerShortName }}
        </a>
      </template>
      <template v-else>
        <template v-if="customerIsBusiness">
          <customer-avatar v-bind:customer-id="customer.id" v-bind:size="size"/>
          {{ customerFullName }}
        </template>
        <template v-else>
          <customer-avatar v-bind:customer-id="customer.id" v-bind:size="size"/>
          <gender-male-icon v-if="customer.sex === 1"></gender-male-icon>
          <gender-female-icon v-if="customer.sex === 0"></gender-female-icon>
          <help-icon v-if="customer.sex === null"></help-icon>
          {{ customerShortName }}
        </template>
      </template>
    </a-tooltip>
  </div>
</template>

<script>
export default {
  name: 'CustomerBadgeComponent',
  props: {
    customer: {
      type: Object,
      required: true
    },
    link: {
      type: Boolean,
      default: true,
    },
    tooltip: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    customerShortName () {
      let shortName = ''

      if (this.customer.initials !== null && this.customer.initials.length > 0) {
        shortName += this.customer.initials
      } else if (this.customer.first_name) {
        shortName += this.customer.first_name
      } else {
        shortName += this.customer.firstName
      }

      if (this.customer.suffix !== null && this.customer.suffix.length > 0) {
        shortName += ' ' + this.customer.suffix
      }

      if (this.customer.last_name) {
        shortName += ' ' + this.customer.last_name
      } else {
        shortName += ' ' + this.customer.lastName

      }

      return shortName
    },
    customerFullName () {
      return this.customer.full_name
    },
    customerDashboardURI () {
      return '/customer/' + this.customer.id + '/dashboard'
    },
    customerIsBusiness () {
      return this.customer.type === 9
    }
  }
}
</script>
